import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label", "filename"]

  connect() {
    console.log("File upload controller connected")
  }

  updateLabel() {
    console.log("updateLabel called")
    const fileName = this.inputTarget.files[0]?.name
    console.log("Selected file:", fileName)
    
    if (fileName) {
      this.labelTarget.textContent = fileName
      
      // Also update filename display if it exists
      if (this.hasFilenameTarget) {
        this.filenameTarget.textContent = fileName
        this.filenameTarget.classList.remove("hidden")
      }
    }
  }
}

